import ErrorMessage from './ErrorMessage';
import Scroller from './Scroller';
import Spinner from './Spinner';
import MessageScreen from './MessageScreen';
import Shrinkable from './Shrinkable';
import SevenSegment from './zoo/SevenSegment';

import asyncComponent from '../asyncComponent';

const AsyncTableauComponent = asyncComponent(() => import('./TableauComponent'));

export {
  ErrorMessage,
  Scroller,
  Spinner,
  MessageScreen,
  Shrinkable,
  SevenSegment,
  AsyncTableauComponent as TableauComponent,
};
